var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-render',{ref:"nameListTableRender",attrs:{"config":_vm.config,"propData":_vm.propData,"rowClassName":function (ref) {
                var row = ref.row;
                var rowIndex = ref.rowIndex;

                return _vm.getUnqualifiedRowConfig({
          row: row,
          rowIndex: rowIndex,
          isNotUnqualified: _vm.isNotUnqualified(row)
        });
},"rowKey":"userId","height":"55vh"}}),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('span',{staticClass:"select-all",on:{"click":_vm.chooseAll}},[_vm._v("全选")]),_vm._v(" "),_c('div',{staticClass:"footer-button-group"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.btLoading},on:{"click":_vm.confirm}},[_vm._v("\n        确认添加\n      ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.cancel}},[_vm._v("取消")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }